<template>
	<component
		class="p-0 m-0"
		v-if="isLoaded"
		:is="layout">
		<router-view />
	</component>
</template>

<script setup lang="ts">
	// components
	import SidebarWithHeader from "@/layouts/Sidebar/SidebarWithHeader.vue"
	
	// router
	import {
		useRoute
	} from "vue-router"

	// vue
	import {
		computed,
		ref
	} from "vue"

	const route = useRoute()
	const isLoaded = ref(true)

	const layout = computed(() => {
		return route.meta.layout || SidebarWithHeader
	})

</script>